import axios from 'axios';
import {API_ADMIN} from '@/utils/constants/Api'
import { BrandModel } from '@/brand/models/BrandModel';
import { IFilterList } from '@/utils/interfaces/FilterListInterface';
import { BaseAssociableEntity, BaseChannelBackendAssociation } from '@c2b/muven-commons';
import { IEntityAssociation } from '../../utils/interfaces/EntityAssociationInterface';
import { BrandFormModel } from '../models/BrandFormModel';

class BrandService implements IEntityAssociation {
    getBrands(page:number, filter:IFilterList):Promise<BrandModel[]> {
        return axios.get(`${API_ADMIN}brands?page=${page}${filter.toPartialQueryString()}`)
            .then(({data}) => {
                return data.map((c:BrandModel) => {
                    return new BrandModel(c)
                })
            })
    }

    getAllBrands():Promise<BrandModel[]> {
        return axios.get(`${API_ADMIN}brands/all`)
            .then(({data}) => {
                return data.map((c:BrandModel) => {
                    return new BrandModel(c)
                })
            })
    }

    createOrUpdateBrand(brand: BrandFormModel):Promise<BrandModel> {
        if (!brand.hasId()) {
            return this.createBrand(brand)
        }

        return this.updateBrand(brand)
    }

    createBrand(brand: BrandFormModel):Promise<BrandModel> {
        return axios.post(`${API_ADMIN}brands`, brand)
            .then(({data}) => {
                return new BrandModel(data)
            })
    }

    updateBrand(brand: BrandFormModel):Promise<BrandModel> {
        return axios.put(`${API_ADMIN}brands/${brand.id}`, brand)
            .then(({data}) => {
                return new BrandModel(data)
            })
    }

    getEntitiesInBackend(channelId:number):Promise<BaseAssociableEntity[]> {
        return axios.get(`${API_ADMIN}brands/in_muven/from_channel/${channelId}`)
            .then(({data}) => {
                return data.map((b:BaseAssociableEntity) => new BaseAssociableEntity(b))
            })
    }

    getEntitiesInChannel(channelId:number):Promise<BaseAssociableEntity[]> {
        return axios.get(`${API_ADMIN}brands/in_channel/${channelId}`)
            .then(({data}) => {
                return data.map((b:BaseAssociableEntity) => new BaseAssociableEntity(b))
            })
    }

    getBrandById(id:number):Promise<BrandModel> {
        return axios.get(`${API_ADMIN}brands/${id}`)
            .then(({data}) => {
                return new BrandModel(data)
            })
    }

    updateAllowExportInBrand(idBrand: number, allowExport:boolean):Promise<any> {
        return axios.patch(`${API_ADMIN}brands/${idBrand}/allow_export/${allowExport}`)
            .then(({data}) => {
                return data
            })
    }

    updateAllowExportInBrandChannel(idBrandChannel: number, allowExport:boolean):Promise<any> {
        return axios.patch(`${API_ADMIN}brands/channel/allow_export/${idBrandChannel}/${allowExport}`)
            .then(({data}) => {
                return data
            })
    }

    associateChannelEntitiesWithBackendEntities(associationList:BaseChannelBackendAssociation[], channelId:number):Promise<any> {
        return axios.post(`${API_ADMIN}brands/association/in_channel/${channelId}`, associationList)
            .then(({data}) => {
                return data
            })    
    }

    deleteBrand(id:number):Promise<any> {
        return axios.delete(`${API_ADMIN}brands/${id}`)
    }

    forceChannelsSync(id:number):Promise<void> {
        return axios.post(`${API_ADMIN}brands/${id}/force_channels_sync`)
    }
}

export default new BrandService()
